const KeywordChart = ({ keywords, title = 'Top Keywords' }) => {
  if (!keywords || keywords.length === 0) return null;

  const maxCount = keywords[0].count;

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>{title} ({keywords.length})</h3>
      <div style={styles.list}>
        {keywords.map(({ word, count }, i) => (
          <div key={word} style={styles.row} className="titler-keyword-row">
            <span style={styles.rank} className="titler-keyword-rank">#{i + 1}</span>
            <span style={styles.word} className="titler-keyword-word">{word}</span>
            <div style={styles.barContainer} className="titler-keyword-bar">
              <div style={{ ...styles.bar, width: `${(count / maxCount) * 100}%` }} />
            </div>
            <span style={styles.count} className="titler-keyword-count">{count}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: { marginTop: '4px' },
  title: { margin: '0 0 16px', color: '#e2e8f0', fontSize: '16px', fontWeight: '600' },
  list: { display: 'flex', flexDirection: 'column', gap: '6px' },
  row: { display: 'flex', alignItems: 'center', gap: '12px' },
  rank: { width: '36px', fontSize: '12px', color: '#64748b', textAlign: 'right', fontFamily: 'monospace' },
  word: { width: '140px', fontSize: '14px', fontWeight: '600', color: '#c4b5fd', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  barContainer: {
    flex: 1, height: '22px', backgroundColor: 'rgba(255,255,255,0.06)',
    borderRadius: '6px', overflow: 'hidden', minWidth: 0,
  },
  bar: {
    height: '100%',
    background: 'linear-gradient(90deg, #7c3aed, #818cf8)',
    borderRadius: '6px', transition: 'width 0.3s ease',
  },
  count: { width: '44px', fontSize: '12px', color: '#64748b', textAlign: 'right', fontFamily: 'monospace', flexShrink: 0 },
};

export default KeywordChart;
